import React, { Component } from 'react'
import { Field } from 'redux-form'
import { Row, Badge } from 'react-bootstrap'

import {
  renderTextField
} from '../../../Forms/fieldRenderers'
import {
  required,
  getNumericValidator
} from '../../../Forms/fieldValidators'

const numeric12 = getNumericValidator(9, 12)

class CamposIngresoCompleto0 extends Component {
  render () {
    const {
      onPrinterChange,
      printerName,
      cpaTextValue,
      onChange
    } = this.props

    return (
      <div>
        <Row className='justify-content-md-center'>
          <Field
            className='cpa-grande'
            name='numero'
            type='text'
            label='Número'
            value={cpaTextValue}
            component={renderTextField}
            autoFocus
            validate={[required, numeric12]}
            placeholder='10200000000'
            onChange={onChange}
          />
        </Row>
        <Row className='justify-content-md-center'>
          {printerName
            ? <Badge variant='primary'
              onClick={onPrinterChange}>
              [ Cambiar {printerName} ]
            </Badge>
            : null}
        </Row>
      </div>
    )
  }
}

export default CamposIngresoCompleto0
